import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrameIn } from 'projects/shared/src/interfaces/frame-in.interface';
import { FrameOutResponse } from 'projects/shared/src/interfaces/frame-out-response.interface';
import { Observable } from 'rxjs';
import { ShHeadersService } from '../headers/sh-headers.service';
import provinciesDealers from 'projects/shared/src/JSON/provinciesDealers.json';
import citiesDealers from 'projects/shared/src/JSON/citiesDealers.json';

@Injectable({
  providedIn: 'root',
})
export class ShDetailSimulationService {
  detailSimulation: any;
  infoCredito: any = {
    accessories: '0',
    brandVehicle: 'HYUNDAI',
    costVehicle: '25000',
    disbursementDate: '',
    inputValue: '15000',
    modelVehicle: 'TUCSON',
    payDay: '9',
    timeCredit: '24',
    timeSafeVehicle: '24',
    worthDeviceTracing: '1200',
    yearVehicle: '2022',
  };

  constructor(
    private http: HttpClient,
    private _shSharedHeaders: ShHeadersService
  ) {}

  setDetailSimulation(dataDetail: any) {
    this.detailSimulation = dataDetail;
  }

  setInfoCredito(dataCredit: any) {
    this.infoCredito = dataCredit;
  }

  getInfoCredito(dataCredit: any) {
    return this.infoCredito;
  }

  shGetCitiesDealers() {
    return citiesDealers;
  }

  shGetProvinciesDealers() {
    return provinciesDealers;
  }

  shGetLoanCalculator(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.get<FrameOutResponse>(`${url}`, {
      headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
    });
  }
}
